const Temple=[
    
{
      src: 'https://i.postimg.cc/KzwGDYxH/DAAN-TEMPLE-INN012.jpg',
      alt: 'Daan Temple Inn',
    },
    {
      src: 'https://i.postimg.cc/X7MNZX2Z/DAAN-TEMPLE-INN019.jpg',
   alt: 'Daan Temple Inn',
    },
    {
      src: 'https://i.postimg.cc/TYrdnGSt/DAAN-TEMPLE-INN027.jpg',
alt: 'Daan Temple Inn',    },
    {
      src: 'https://i.postimg.cc/YCMp3ZBM/DAAN-TEMPLE-INN029.jpg',
alt: 'Daan Temple Inn',    },
    {
      src: 'https://i.postimg.cc/8z4Tn4TW/DAAN-TEMPLE-INN033.jpg',
alt: 'Daan Temple Inn',    }, {
      src: 'https://i.postimg.cc/0NN9gSN4/DAAN-TEMPLE-INN042.jpg',
   alt: 'Daan Temple Inn',
    }, {
      src: 'https://i.postimg.cc/52NhjVMY/DAAN-TEMPLE-INN041.jpg',
    alt: 'Daan Temple Inn',
    }, {
      src: 'https://i.postimg.cc/nhR6DPHd/DAAN-TEMPLE-INN055.jpg',
     alt: 'Daan Temple Inn',
    }, {
      src: 'https://i.postimg.cc/W4xC9qqg/DAAN-TEMPLE-INN063.jpg',
alt: 'Daan Temple Inn',
    },{
      src: 'https://i.postimg.cc/fL4q741v/DAAN-TEMPLE-INN066.jpg',
      alt: 'Daan Temple Inn',
    },{
      src: 'https://i.postimg.cc/gcHthTsv/DAAN-TEMPLE-INN095.jpg',
alt: 'Daan Temple Inn',
    },
    {
      src: 'https://i.postimg.cc/025W00Xh/DAAN-TEMPLE-INN090.jpg',
alt: 'Daan Temple Inn',
    },

]

export default Temple;